export class ConsumerDetailInjector {
    constructor(public issues: any[], public consumerHasPayg?: boolean, public consumerHasBilling?: boolean) { }
}
